import React, { useState, useEffect } from "react";
import PopupWin from "../../../../../components/PopupWin";

const DuplicateMappingModal = ({ visible, onClose, onConfirm, existingNames, originalName }) => {
  const [newName, setNewName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Reset when modal opens
  useEffect(() => {
    if (visible) {
      setNewName("");
      setErrorMessage("");
    }
  }, [visible]);

  const handleNameChange = (e) => {
    const value = e.target.value;

    // Limit to 99 characters
    if (value.length > 99) {
      return;
    }

    setNewName(value);

    // Check for unique name
    if (value.trim() === "") {
      setErrorMessage("");
    } else if (existingNames.includes(value.trim())) {
      setErrorMessage("This name already exists. Please choose a different name.");
    } else {
      setErrorMessage("");
    }
  };

  const handleConfirm = () => {
    const trimmedName = newName.trim();

    if (trimmedName === "") {
      return; // Button should be disabled
    }

    if (existingNames.includes(trimmedName)) {
      setErrorMessage("This name already exists. Please choose a different name.");
      return;
    }

    onConfirm(trimmedName);
  };

  const isNameValid = newName.trim() !== "" && !existingNames.includes(newName.trim());

  return (
    <PopupWin
      visible={visible}
      onClose={onClose}
      hideClose={false}
      popupStyle={{
        width: "427px",
        minHeight: "250px",
        padding: 0,
        background: "#ffffff",
        borderRadius: "10px",
        boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
      }}
      contentStyle={{
        padding: "40px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <h2 className="duplicate-mapping-modal-title">Create New Field Mapping</h2>
      <p className="duplicate-mapping-modal-description">
        Duplicating from: <strong>{originalName}</strong>
      </p>

      <div className="duplicate-mapping-modal-form">
        <label className="duplicate-mapping-modal-label">
          Field Mapping Name <span className="required">*</span>
        </label>
        <input
          type="text"
          className={`duplicate-mapping-modal-input ${errorMessage ? "error" : ""}`}
          placeholder="Enter mapping name"
          value={newName}
          onChange={handleNameChange}
          maxLength={39}
          autoFocus
        />
        {errorMessage && (
          <span className="duplicate-mapping-modal-error">{errorMessage}</span>
        )}
      </div>

      <div className="duplicate-mapping-modal-buttons">
        <button className="duplicate-mapping-modal-cancel" onClick={onClose}>
          Cancel
        </button>
        <button
          className="duplicate-mapping-modal-confirm"
          onClick={handleConfirm}
          disabled={!isNameValid}
        >
          Save
        </button>
      </div>
    </PopupWin>
  );
};

export default DuplicateMappingModal;
